// src/analytics/CookieConsentBanner.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  acceptAnalytics,
  rejectAnalytics,
  shouldShowBanner,
  getConsentState,
  subscribeCookieUIEvents,
} from "./cookieConsent";

export default function CookieConsentBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show banner only if user hasn't chosen yet
    setOpen(shouldShowBanner());

    // Listen for footer "Cookie Settings" and consent changes
    const unsub = subscribeCookieUIEvents({
      onOpen: () => setOpen(true),
      onChange: () => setOpen(shouldShowBanner()),
    });

    return unsub;
  }, []);

  if (!open) return null;

  const consent = getConsentState();

  const onAccept = () => {
    acceptAnalytics();
    setOpen(false);
  };

  const onReject = () => {
    rejectAnalytics();
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] px-3 pb-3">
      <div className="max-w-5xl mx-auto bg-white border rounded-xl shadow-lg px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="text-sm text-slate-800 leading-6">
          We use cookies for login and optional analytics to improve Piano With
          Pan.{" "}
          <Link to="/privacy-policy" className="text-sky-700 hover:underline">
            Learn more
          </Link>
          {consent.analytics === "granted" ? (
            <span className="ml-2 text-slate-500">(Accepted)</span>
          ) : consent.analytics === "denied" ? (
            <span className="ml-2 text-slate-500">(Rejected)</span>
          ) : null}
        </div>

        <div className="flex items-center gap-2 justify-end">
          <button
            type="button"
            onClick={onReject}
            className="px-4 py-2 rounded-lg border text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:opacity-95"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}